/**
 * @Author: Scott Fogelgren
 * @Date:   2019-01-29T00:28:07-05:00
 * @Email:  sfogelgren@comsearch.com
 * @Project: Project Insight
 * @Last modified by:   Scott Fogelgren
 * @Last modified time: 2019-01-30T13:53:43-05:00
 * @Copyright: // Copyright (c) 2019 Comsearch, Inc., All rights reserved
 */

import Amplify from 'aws-amplify'
import { Auth } from 'constants/userPool'

// Configue Amplify with Cognito User Pool ids and AWS region
const awsConfig = Amplify.configure({ Auth })

export default awsConfig
